import React from 'react';
import { List, Icon } from 'semantic-ui-react';
import memberEntities from '@/users/membership/constants';
import entityIcons from '@/constants/images';
import LinkifyWrapper from '@/components/LinkifyWrapper';

const RequestApproversListItem = ({ member }) => (
  <List.Item className="mb-0">
    {member.entity === memberEntities.USERGROUP && (
      <span>
        <Icon name={entityIcons.usergroup} className="primary" />
        {member.name}
      </span>
    )}
    {member.entity === memberEntities.USER && (
    <span>
      <Icon name={entityIcons.user} className="primary" />
      <LinkifyWrapper>{member.email}</LinkifyWrapper>
    </span>
    )}
  </List.Item>
);

export default RequestApproversListItem;
